var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-tree-demo"}},[_c('tree-dropdown'),_c('tree-search-tree'),_c('tree-async-tree')],1)}
var staticRenderFns = []

export { render, staticRenderFns }